import { BaseTaxonomy, Taxonomy } from '../contracts';
import { removePropertiesWithNullishValues, snakeCaseKeys } from '../helpers';

export const ANALYTICS_BASE_TAXONOMY: Omit<BaseTaxonomy, 'section' | 'page'> = {
    countryCode: 'gb',
    platform: 'React',
    brandPrimary: 'zoopla',
    brand: 'zoopla'
};

export const getPageTrackingData = (
    page: string,
    extraTaxonomy: Record<string, unknown> = {},
    extraEcommerce: Record<string, unknown> | null = null
) => {
    const baseTaxonomy = {
        ...ANALYTICS_BASE_TAXONOMY,
        page
    };

    /* eslint-disable @typescript-eslint/consistent-type-assertions */
    const taxonomy = snakeCaseKeys(
        removePropertiesWithNullishValues({
            ...baseTaxonomy,
            ...extraTaxonomy
        })
    ) as Taxonomy;
    /* eslint-enable @typescript-eslint/consistent-type-assertions */

    const ecommerce = extraEcommerce
        ? snakeCaseKeys(removePropertiesWithNullishValues(extraEcommerce))
        : null;

    return {
        taxonomy,
        ...(ecommerce && { ecommerce })
    };
};
